import React, { memo, useCallback, useMemo } from 'react';

import { InfoIcon } from '@sharedCR/coreDesignSystem/icons';
import { ActionCellButtonCDS } from '@sharedCR/coreDesignSystem/Table/TableCDS/cellContent';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

import { LoanConditionTasksTableTestIds } from '../../LoanConditionTasksTable.testIds';

const RowActionButton = ({ name, slaGroupId, taskId, onOpenTaskSLAGroupInfo }) => {
  const onOpenSLAGroupInfo = useCallback(
    () => onOpenTaskSLAGroupInfo({ name, slaGroupId, taskId }),
    [name, slaGroupId, taskId, onOpenTaskSLAGroupInfo],
  );

  const items = useMemo(
    () => [
      {
        text: 'SLA Level Details',
        onClick: onOpenSLAGroupInfo,
        icon: <InfoIcon size={IconSize[20]} />,
        'data-testid': LoanConditionTasksTableTestIds.getTaskSlaInfoButtonId(taskId),
      },
    ],
    [taskId, onOpenSLAGroupInfo],
  );

  return <ActionCellButtonCDS isHidden={!slaGroupId} items={items} />;
};

RowActionButton.propTypes = {
  name: PropTypes.string.isRequired,
  taskId: PropTypes.string.isRequired,
  onOpenTaskSLAGroupInfo: PropTypes.func.isRequired,
  slaGroupId: PropTypes.string,
};

export default memo(RowActionButton);
